<ion-content [fullscreen]="true" class="page-content" color="light">
  @if (analyticsTutorialMode) {
    @defer (on immediate) { <app-analytics-tutorial></app-analytics-tutorial> }
  } @else {
  <div style="width: 100%;">
    <div
      style="width: 80%; margin: 30px auto 10px auto; display: flex; justify-content: space-between; align-items: center;">
      <breadcrumbs [breadcrumbsList]="breadcrumbsList"></breadcrumbs>
    </div>
  </div>
  <!-- Dashboard -->
  <div style="width: 100%;">
    <div class="filter-toolbar">
      <div class="filter-header">
        <ion-icon name="filter" class="filter-icon"></ion-icon>
        <span class="filter-label">Filtra Visualizzazione</span>

        @if(hasActiveFilters) {
        <div class="reset-badge" (click)="resetContext()">
          <span>Reset</span>
          <ion-icon name="close-circle"></ion-icon>
        </div>
        }
      </div>
      <div class="filter-group">
        @if(isSuperUser) {
        <mat-form-field appearance="outline" class="compact-select">
          <mat-label>Cliente</mat-label>
          <mat-select [(ngModel)]="currentContext.customerId" (selectionChange)="onContextChange('customer')">
            <mat-option [value]="null">Tutti</mat-option>
            @for(c of customersList; track c.id) {
            <mat-option [value]="c.id">{{ c.businessName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        }

        @if(isSuperUser) {
        <mat-form-field appearance="outline" class="compact-select">
          <mat-label>Organizzazione</mat-label>
          <mat-select [(ngModel)]="currentContext.organizationId" (selectionChange)="onContextChange('organization')"
            [disabled]="!currentContext.customerId">
            <mat-option [value]="null">Tutte</mat-option>
            @for(o of organizationsList; track o.id) {
            <mat-option [value]="o.id">{{ o.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        }

        <mat-form-field appearance="outline" class="compact-select">
          <mat-label>Edificio</mat-label>
          <mat-select [(ngModel)]="currentContext.buildingId" (selectionChange)="onContextChange('building')"
            [disabled]="!currentContext.organizationId">
            <mat-option [value]="null">Tutti</mat-option>
            @for(b of buildingsList; track b.id) {
            <mat-option [value]="b.id">{{ b.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="compact-select">
          <mat-label>Unità</mat-label>
          <mat-select [(ngModel)]="currentContext.unitId" (selectionChange)="onContextChange('unit')"
            [disabled]="!currentContext.buildingId">
            <mat-option [value]="null">Tutte</mat-option>
            @for(u of unitsList; track u.id) {
            <mat-option [value]="u.id">{{ u.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>

      </div>
      @if(isContextLoading) {
      <div class="loading-line"></div>
      }
    </div>
    <section class="modern-dashboard" aria-label="Nuove statistiche struttura">
      <div class="modern-dashboard__header">
        <div>
          <h1>Statistiche struttura</h1>
        </div>
        <div class="modern-dashboard__actions">
          <button type="button" mat-stroked-button class="dashboard-cards-trigger"
            [matMenuTriggerFor]="dashboardCardsMenu" aria-label="Personalizza le card visualizzate">
            <mat-icon>dashboard_customize</mat-icon>
            Personalizza
          </button>
          <mat-menu #dashboardCardsMenu="matMenu" xPosition="before">
            <div class="dashboard-cards-menu" (click)="$event.stopPropagation()">
              <div class="dashboard-cards-menu__header">
                <strong>Card visualizzate</strong>
                <span>Le preferenze vengono salvate automaticamente</span>
              </div>
              <div class="dashboard-cards-menu__list">
                @for(card of availableDashboardCards; track card.id) {
                <mat-checkbox [checked]="card.visible"
                  (change)="setDashboardCardVisibility(card.id, $event.checked)">
                  {{ card.label }}
                </mat-checkbox>
                }
              </div>
              <button type="button" class="dashboard-cards-menu__reset" (click)="showAllDashboardCards()">
                <mat-icon>restart_alt</mat-icon>
                Mostra tutte
              </button>
            </div>
          </mat-menu>

          <mat-button-toggle-group class="period-toggle" [value]="newDashboardPeriod"
            (change)="onNewDashboardPeriodChange($event.value)" aria-label="Periodo statistiche">
            <mat-button-toggle value="24h">
              <mat-icon>calendar_today</mat-icon>
              Ultime 24 ore
            </mat-button-toggle>
            <mat-button-toggle value="7d">Ultimi 7 giorni</mat-button-toggle>
            <mat-button-toggle value="30d">Ultimi 30 giorni</mat-button-toggle>
            <mat-button-toggle value="1y">Ultimi 12 mesi</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
      </div>

      <div class="modern-kpi-grid">
        @if(isDashboardCardVisible('kpi_sensors')) {
        <article class="modern-card modern-kpi modern-kpi--detail"
          [class.modern-kpi--expanded]="sensorsDetailsOpen" [attr.aria-expanded]="sensorsDetailsOpen">
          <div class="modern-kpi__icon modern-kpi__icon--green"><mat-icon>wifi</mat-icon></div>
          <div class="modern-kpi__copy">
            <span>Sensori operativi</span>
            <div class="modern-kpi__value-row">
              @if(getWidget('kpi_sensors')?.data; as sensors) {
                <strong>{{sensors.online}}<small>/{{sensors.total}}</small></strong>
              } @else { <strong>—</strong> }
            </div>
            <div class="modern-kpi__meta">
              <em>{{getWidget('kpi_sensors')?.data?.total ? onlineSensorsPercentage + '% online' : '—'}}</em>
              <button type="button" class="modern-kpi__details" (click)="onSensorsDetailsChange(!sensorsDetailsOpen)"
                aria-controls="sensor-connectivity-details" [attr.aria-label]="sensorsDetailsOpen ? 'Nascondi il dettaglio dei sensori' : 'Vedi il dettaglio dei sensori'">
                <span>Dettagli</span><mat-icon>{{sensorsDetailsOpen ? 'expand_less' : 'expand_more'}}</mat-icon>
              </button>
            </div>
          </div>
        </article>
        }

        @if(isDashboardCardVisible('kpi_events')) {
        <article class="modern-card modern-kpi modern-kpi--detail"
          [class.modern-kpi--expanded]="isKpiDetailOpen('events')"
          [attr.aria-expanded]="isKpiDetailOpen('events')">
          <div class="modern-kpi__icon modern-kpi__icon--blue"><mat-icon>insights</mat-icon></div>
          <div class="modern-kpi__copy">
            <span>Eventi rilevati</span>
            <div class="modern-kpi__value-row">
              <strong>{{ eventsTotal }}</strong>
              @if (kpiPeriodComparison('events'); as comparison) {
              <span class="modern-kpi__comparison"
                [class.positive]="comparison.value > 0" [class.negative]="comparison.value < 0"
                [class.neutral]="comparison.value === 0">
                @if(comparison.value === 0) {
                <b>=</b>
                } @else {
                <mat-icon class="modern-kpi__comparison-trend">{{ comparison.value >= 0 ? 'trending_up' : 'trending_down' }}</mat-icon>
                }
                <b>{{ comparison.value > 0 ? '+' : '' }}{{ comparison.value }}%</b>
                <mat-icon class="modern-kpi__comparison-info"
                  matTooltip="Variazione percentuale rispetto al periodo precedente">info_outline</mat-icon>
              </span>
              }
            </div>
            <div class="modern-kpi__meta">
              <em>{{ newDashboardPeriodLabel }}</em>
              <button type="button" class="modern-kpi__details" (click)="toggleKpiDetails('events')"
                aria-controls="kpi-details-panel"
                [attr.aria-label]="isKpiDetailOpen('events') ? 'Nascondi il dettaglio degli eventi' : 'Vedi il dettaglio degli eventi rilevati'">
                <span>Dettagli</span>
                <mat-icon>{{ isKpiDetailOpen('events') ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
            </div>
          </div>
        </article>
        }

        @if(isDashboardCardVisible('kpi_falls')) {
        <article class="modern-card modern-kpi modern-kpi--detail"
          [class.modern-kpi--expanded]="isKpiDetailOpen('falls')"
          [attr.aria-expanded]="isKpiDetailOpen('falls')">
          <div class="modern-kpi__icon modern-kpi__icon--red">
            <mat-icon class="modern-kpi__fall-icon" fontSet="material-symbols-outlined">falling</mat-icon>
          </div>
          <div class="modern-kpi__copy">
            <span>Cadute rilevate</span>
            <div class="modern-kpi__value-row">
              <strong>{{ fallsTotal }}</strong>
              @if (kpiPeriodComparison('falls'); as comparison) {
              <span class="modern-kpi__comparison"
                [class.negative]="comparison.value > 0" [class.positive]="comparison.value < 0"
                [class.neutral]="comparison.value === 0">
                @if(comparison.value === 0) {
                <b>=</b>
                } @else {
                <mat-icon class="modern-kpi__comparison-trend">{{ comparison.value >= 0 ? 'trending_up' : 'trending_down' }}</mat-icon>
                }
                <b>{{ comparison.value > 0 ? '+' : '' }}{{ comparison.value }}%</b>
                <mat-icon class="modern-kpi__comparison-info"
                  matTooltip="Variazione percentuale rispetto al periodo precedente">info_outline</mat-icon>
              </span>
              }
            </div>
            <div class="modern-kpi__meta">
              <em>{{ newDashboardPeriodLabel }}</em>
              <button type="button" class="modern-kpi__details" (click)="toggleKpiDetails('falls')"
                aria-controls="kpi-details-panel"
                [attr.aria-label]="isKpiDetailOpen('falls') ? 'Nascondi il dettaglio delle cadute' : 'Vedi il dettaglio delle cadute rilevate'">
                <span>Dettagli</span>
                <mat-icon>{{ isKpiDetailOpen('falls') ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
            </div>
          </div>
        </article>
        }

        @if(isDashboardCardVisible('kpi_response_time')) {
        <article class="modern-card modern-kpi modern-kpi--detail"
          [class.modern-kpi--expanded]="isKpiDetailOpen('responseTime')"
          [attr.aria-expanded]="isKpiDetailOpen('responseTime')">
          <div class="modern-kpi__icon modern-kpi__icon--blue"><mat-icon>timer</mat-icon></div>
          <div class="modern-kpi__copy">
            <span>Tempo mediano di presa in carico</span>
            <div class="modern-kpi__value-row">
              <strong class="modern-kpi__time">{{ medianResponseTime }}</strong>
              @if (kpiPeriodComparison('responseTime'); as comparison) {
              <span class="modern-kpi__comparison"
                [class.negative]="comparison.value > 0" [class.positive]="comparison.value < 0"
                [class.neutral]="comparison.value === 0">
                @if(comparison.value === 0) {
                <b>=</b>
                } @else {
                <mat-icon class="modern-kpi__comparison-trend">{{ comparison.value >= 0 ? 'trending_up' : 'trending_down' }}</mat-icon>
                }
                <b>{{ comparison.value > 0 ? '+' : '' }}{{ comparison.value }}%</b>
                <mat-icon class="modern-kpi__comparison-info"
                  matTooltip="Variazione percentuale rispetto al periodo precedente">info_outline</mat-icon>
              </span>
              }
            </div>
            <div class="modern-kpi__meta">
              <em>{{ newDashboardPeriodLabel }}</em>
              <button type="button" class="modern-kpi__details" (click)="toggleKpiDetails('responseTime')"
                aria-controls="kpi-details-panel"
                [attr.aria-label]="isKpiDetailOpen('responseTime') ? 'Nascondi il dettaglio del tempo mediano' : 'Vedi il dettaglio del tempo mediano di presa in carico'">
                <span>Dettagli</span>
                <mat-icon>{{ isKpiDetailOpen('responseTime') ? 'expand_less' : 'expand_more' }}</mat-icon>
              </button>
            </div>
          </div>
        </article>
        }
      </div>

      @if(sensorsDetailsOpen && isDashboardCardVisible('kpi_sensors')) {
        @defer (on immediate) {
          <app-sensor-connectivity panelId="sensor-connectivity-details" [period]="newDashboardPeriod" [customerId]="currentContext.customerId"
            [organizationId]="currentContext.organizationId" [buildingId]="currentContext.buildingId" [unitId]="currentContext.unitId"
            [expanded]="true" (expandedChange)="onSensorsDetailsChange($event)"></app-sensor-connectivity>
        }
      }

      @if(activeKpiDetail) {
      <article id="kpi-details-panel" class="modern-card kpi-details-panel"
        [class.kpi-details-panel--from-left]="activeKpiDetail === 'events'"
        [class.kpi-details-panel--from-right]="activeKpiDetail === 'responseTime'"
        role="region" aria-live="polite" aria-labelledby="kpi-details-title">
        <header class="kpi-details-panel__header">
          <div class="kpi-details-panel__heading">
            <h2 id="kpi-details-title">{{ activeKpiDetailTitle }}</h2>
          </div>
          <button type="button" mat-icon-button (click)="closeKpiDetails()" aria-label="Chiudi dettagli">
            <mat-icon>close</mat-icon>
          </button>
        </header>

        @if(kpiDetailsLoading) {
        <div class="kpi-details-panel__state">
          <ion-spinner name="crescent"></ion-spinner>
          <span>Caricamento dettagli...</span>
        </div>
        } @else if(kpiDetailsUnavailable) {
        <div class="kpi-details-panel__state">
          <mat-icon>cloud_off</mat-icon>
          <strong>Dettagli non disponibili</strong>
          <span>Il servizio di dettaglio non ha restituito dati.</span>
        </div>
        } @else if(kpiDetails) {
        @if(hasKpiDetailsChart) {
        <section class="kpi-details-chart" aria-labelledby="kpi-details-chart-title">
          <div class="kpi-details-chart__header">
            <div class="kpi-details-chart__title">
              <h3 id="kpi-details-chart-title">{{ activeKpiDetailChartTitle }}</h3>
            </div>
            <mat-button-toggle-group class="period-toggle kpi-comparison-mode" [value]="kpiComparisonMode"
              (change)="setKpiComparisonMode($event.value)" aria-label="Modalita di visualizzazione">
              <mat-button-toggle value="absolute">Valori</mat-button-toggle>
              <mat-button-toggle value="variation"
                title="Variazione percentuale rispetto al bucket temporale precedente">Variazione %</mat-button-toggle>
            </mat-button-toggle-group>
          </div>

          @if(activeKpiDetail !== 'responseTime') {
          <div class="kpi-comparison-controls">
            <mat-form-field appearance="outline" class="compact-select kpi-comparison-select">
              <mat-label>Confronta per</mat-label>
              <mat-select [value]="kpiComparisonLevel"
                (selectionChange)="onKpiComparisonLevelChange($event.value)">
                @for(level of availableKpiComparisonLevels; track level.value) {
                <mat-option [value]="level.value">{{ level.label }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <button type="button" mat-stroked-button class="dashboard-cards-trigger"
              [matMenuTriggerFor]="comparisonSeriesMenu">
              <mat-icon>add</mat-icon>
              Aggiungi serie
            </button>

            <mat-chip-set class="kpi-comparison-legend" aria-label="Serie visualizzate">
            <mat-chip>
              <span class="kpi-comparison-dot kpi-comparison-dot--total"></span>
              Totale struttura
            </mat-chip>
            @for(option of selectedKpiComparisonOptions; track option.id) {
            <mat-chip (removed)="removeKpiComparison(option.id)">
              <span class="kpi-comparison-dot" [style.background]="kpiComparisonColor(option.id)"></span>
              {{ option.label }}
              <button matChipRemove [attr.aria-label]="'Rimuovi ' + option.label">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip>
            }
            </mat-chip-set>
          </div>
          }

          <div echarts [options]="kpiDetailsChartOptions" [autoResize]="true" class="kpi-details-chart__canvas"></div>

          <mat-menu #comparisonSeriesMenu="matMenu" class="kpi-comparison-menu">
            <div class="kpi-comparison-menu__content" (click)="$event.stopPropagation()">
              @if(isEventKpiDetail) {
              <div class="kpi-comparison-menu__search">
                <mat-icon>search</mat-icon>
                <input type="search" placeholder="Cerca {{ activeKpiComparisonLevelLabel.toLowerCase() }}"
                  [ngModel]="kpiComparisonSearch"
                  (ngModelChange)="onKpiComparisonSearchChange($event)"
                  (keydown)="$event.stopPropagation()"
                  aria-label="Cerca entita da confrontare">
              </div>
              }

              @if(kpiComparisonOptionsLoading) {
              <div class="kpi-comparison-menu__state"><ion-spinner name="crescent"></ion-spinner> Caricamento...</div>
              } @else if(kpiComparisonOptionsUnavailable) {
              <div class="kpi-comparison-menu__state">Opzioni non disponibili</div>
              } @else if(!kpiComparisonOptions.length) {
              <div class="kpi-comparison-menu__state">Nessun risultato</div>
              } @else {
                @for(option of kpiComparisonOptions; track option.id) {
                <button type="button" mat-menu-item (click)="toggleKpiComparison(option.id)"
                  [disabled]="!canSelectKpiComparison(option.id)" [title]="option.hierarchyPath || option.label">
                  <mat-icon>{{ isKpiComparisonSelected(option.id) ? 'check_box' : 'check_box_outline_blank' }}</mat-icon>
                  <span class="kpi-comparison-menu__option">
                    <b>{{ option.label }}</b>
                    @if(option.hierarchyPath) { <small>{{ option.hierarchyPath }}</small> }
                  </span>
                </button>
                }
              }

              @if(isEventKpiDetail && kpiComparisonTotalPages > 1) {
              <div class="kpi-comparison-menu__pagination">
                <button type="button" mat-icon-button (click)="goToKpiComparisonPage(kpiComparisonPage - 1)"
                  [disabled]="kpiComparisonPage <= 1" aria-label="Pagina precedente">
                  <mat-icon>chevron_left</mat-icon>
                </button>
                <span>{{ kpiComparisonPage }} / {{ kpiComparisonTotalPages }}</span>
                <button type="button" mat-icon-button (click)="goToKpiComparisonPage(kpiComparisonPage + 1)"
                  [disabled]="kpiComparisonPage >= kpiComparisonTotalPages" aria-label="Pagina successiva">
                  <mat-icon>chevron_right</mat-icon>
                </button>
              </div>
              }
            </div>
          </mat-menu>
        </section>
        }

        }
      </article>
      }

      @if(isSuperUser) {
      <section class="usage-dashboard" aria-label="Statistiche di utilizzo">
        <div class="usage-dashboard__grid">
          @if(isDashboardCardVisible('usage_adoption')) {
          <article class="modern-card usage-card usage-card--adoption modern-panel--detail"
            [class.modern-panel--expanded]="usageUsersDetailsOpen"
            [attr.aria-expanded]="usageUsersDetailsOpen">
            <div class="usage-card__header">
              <div>
                <h3>Utenti attivi</h3>
                <mat-icon [matTooltip]="'Utenti con almeno una sessione nelle ' + newDashboardPeriodContextLabel + ', rispetto agli utenti abilitati'">info_outline</mat-icon>
              </div>
              <button type="button" mat-stroked-button class="modern-panel__details-trigger"
                (click)="toggleUsageUsersDetails()" aria-controls="usage-users-details-panel"
                [attr.aria-label]="usageUsersDetailsOpen ? 'Nascondi utilizzo per utente' : 'Vedi utilizzo per utente'">
                {{ usageUsersDetailsOpen ? 'Nascondi dettagli' : 'Vedi dettagli' }}
              </button>
            </div>
            @if(usageSummaryLoading) {
            <div class="usage-card__state"><ion-spinner name="crescent"></ion-spinner></div>
            } @else if(usageSummaryUnavailable) {
            <div class="usage-card__state">Dati di utilizzo non disponibili</div>
            } @else {
            <div class="usage-adoption">
              <div echarts [options]="usageAdoptionGaugeOptions" [autoResize]="true"
                class="usage-adoption__chart" role="img"
                [attr.aria-label]="(usageSummary?.activeUsers || 0) + ' utenti attivi su ' + (usageSummary?.totalUsers || 0)"></div>
              <div class="usage-adoption__ratio">
                <strong>{{ usageSummary?.activeUsers || 0 }}</strong>
                <span>su {{ usageSummary?.totalUsers || 0 }} utenti</span>
              </div>
              <div class="usage-adoption__metrics">
                <span><small>Tempo unico</small><b>{{ formatUsageDuration(usageSummary?.uniqueDurationMs) }}</b></span>
                <span><small>Streaming</small><b>{{ formatUsageDuration(usageSummary?.streamingUniqueDurationMs) }}</b></span>
              </div>
            </div>
            }
          </article>
          }

          @if(isDashboardCardVisible('usage_daily')) {
          <article class="modern-card usage-card usage-card--daily modern-panel--detail"
            [class.modern-panel--expanded]="usageDailyDetailsOpen"
            [attr.aria-expanded]="usageDailyDetailsOpen">
            <div class="usage-card__header">
              <div>
                <h3>Utilizzo giornaliero</h3>
                <mat-icon matTooltip="Tempo unico dell’applicazione e dello streaming nel periodo selezionato">info_outline</mat-icon>
              </div>
              <button type="button" mat-stroked-button class="modern-panel__details-trigger"
                (click)="toggleUsageDailyDetails()" aria-controls="usage-daily-details-panel"
                [attr.aria-label]="usageDailyDetailsOpen ? 'Nascondi quando viene usato il sistema' : 'Vedi quando viene usato il sistema'">
                {{ usageDailyDetailsOpen ? 'Nascondi dettagli' : 'Vedi dettagli' }}
              </button>
            </div>
            @if(usageDailyLoading) {
            <div class="usage-card__state"><ion-spinner name="crescent"></ion-spinner></div>
            } @else if(usageDailyUnavailable) {
            <div class="usage-card__state">Andamento utilizzo non disponibile</div>
            } @else {
            <div echarts [options]="usageDailyChartOptions" [autoResize]="true"
              class="usage-daily-chart" role="img"
              [attr.aria-label]="'Utilizzo del sistema nelle ' + newDashboardPeriodContextLabel"></div>
            }
          </article>
          }

          @if(usageUsersDetailsOpen && isDashboardCardVisible('usage_adoption')) {
          <article id="usage-users-details-panel"
            class="modern-card usage-card usage-card--users usage-card--users-detail"
            role="region" aria-live="polite" aria-labelledby="usage-users-title">
            <div class="usage-card__header">
              <div>
                <h3 id="usage-users-title">Utilizzo per utente</h3>
                <mat-icon matTooltip="Utenti ordinati per tempo unico di utilizzo">info_outline</mat-icon>
              </div>
              <button type="button" mat-icon-button class="usage-card__close"
                (click)="closeUsageUsersDetails()" aria-label="Chiudi utilizzo per utente">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            @if(usageUsersPreviewLoading) {
            <div class="usage-card__state"><ion-spinner name="crescent"></ion-spinner></div>
            } @else if(usageUsersPreviewUnavailable) {
            <div class="usage-card__state">Dati per utente non disponibili</div>
            } @else if(usageUsersPreview?.users?.length) {
            <div echarts [options]="usageUsersPreviewOptions" [autoResize]="true"
              class="usage-users-preview" role="img" aria-label="Utenti con maggiore tempo unico di utilizzo"></div>
            } @else {
            <div class="usage-card__state">Nessun utilizzo nel periodo selezionato</div>
            }
          </article>
          }

          @if(usageDailyDetailsOpen && isDashboardCardVisible('usage_daily')) {
          <article id="usage-daily-details-panel"
            class="modern-card usage-details-panel usage-heatmap-panel"
            role="region" aria-live="polite" aria-labelledby="usage-heatmap-title">
            <header class="usage-details-panel__header usage-details-panel__header--heatmap">
              <div>
                <h3 id="usage-heatmap-title">Quando viene usato</h3>
                <span>Tempo unico per giorno della settimana e ora</span>
              </div>
              <mat-button-toggle-group class="period-toggle usage-kind-toggle" [value]="usageHeatmapKind"
                (change)="onUsageHeatmapKindChange($event.value)" aria-label="Tipo utilizzo heatmap">
                <mat-button-toggle value="application_usage">Applicazione</mat-button-toggle>
                <mat-button-toggle value="streaming_view">Streaming</mat-button-toggle>
              </mat-button-toggle-group>
              <button type="button" mat-icon-button (click)="closeUsageDailyDetails()"
                aria-label="Chiudi quando viene usato"><mat-icon>close</mat-icon></button>
            </header>

            @if(usageHeatmapLoading) {
            <div class="usage-card__state usage-card__state--details"><ion-spinner name="crescent"></ion-spinner></div>
            } @else if(usageHeatmapUnavailable) {
            <div class="usage-card__state usage-card__state--details">Heatmap utilizzo non disponibile</div>
            } @else {
            <div class="usage-heatmap">
              @for(row of usageHeatmapRows; track row.weekday) {
              <div class="usage-heatmap__row">
                <span>{{ row.label }}</span>
                <div class="usage-heatmap__cells">
                  @for(cell of row.cells; track cell.hour) {
                  <i [style.background]="usageHeatmapCellColor(cell.durationMs)"
                    [matTooltip]="row.label + ' ' + cell.hour + ':00-' + (cell.hour + 1) + ':00 · ' + formatUsageDuration(cell.durationMs) + ' · ' + cell.activeUsers + ' utenti'"></i>
                  }
                </div>
              </div>
              }
              <div class="usage-heatmap__hours">
                <span></span>
                <div>
                  @for(hour of usageHeatmapHours; track hour; let index = $index) {
                  <small [class.is-hidden]="index % 2 !== 0">{{ hour }}</small>
                  }
                </div>
              </div>
              <div class="usage-heatmap__legend">
                <span>Meno utilizzo</span>
                <div><i></i><i></i><i></i><i></i><i></i></div>
                <span>Pi&ugrave; utilizzo</span>
              </div>
            </div>
            }
          </article>
          }
        </div>
      </section>
      }

      <div class="modern-main-grid">
        @if(isDashboardCardVisible('hourly_heatmap')) {
        <article class="modern-card heatmap-summary-card modern-panel--detail"
          [class.modern-panel--expanded]="heatmapDetailsOpen"
          [attr.aria-expanded]="heatmapDetailsOpen">
          <div class="heatmap-summary-card__header">
            <div>
              <h2>Numero di allerte rilevate per fascia oraria</h2>
              <mat-icon [matTooltip]="'Distribuzione delle allerte nel periodo selezionato: ' + newDashboardPeriodContextLabel">info_outline</mat-icon>
            </div>
            <button type="button" mat-stroked-button class="heatmap-summary-card__details"
              (click)="toggleHeatmapDetails()" aria-controls="heatmap-details-panel"
              [attr.aria-label]="heatmapDetailsOpen ? 'Nascondi il dettaglio delle fasce orarie' : 'Vedi il dettaglio delle fasce orarie'">
              {{ heatmapDetailsOpen ? 'Nascondi dettagli' : 'Vedi dettagli' }}
            </button>
          </div>

          @if(operationsSummaryLoading) {
          <div class="heatmap-summary-card__loader"><ion-spinner name="crescent"></ion-spinner></div>
          } @else if(operationsSummaryUnavailable) {
          <div class="modern-empty">Dati sulle fasce orarie non disponibili</div>
          } @else {
          <div class="time-slot-summary" role="img" aria-label="Distribuzione delle allerte per fascia oraria">
            @for(slot of heatmapSummarySlots; track slot.label) {
            <div class="time-slot-summary__row">
              <span>{{ slot.label }}</span>
              <div class="time-slot-summary__track">
                <i [class.is-most-frequent]="slot.mostFrequent" [style.width.%]="slot.percentage"></i>
              </div>
              <strong>{{ slot.value }}</strong>
              @if(slot.mostFrequent) {
              <em>Pi&ugrave; frequente</em>
              }
            </div>
            }
          </div>
          }
        </article>
        }
        @if(isDashboardCardVisible('event_types')) {
        <article class="modern-card modern-panel modern-panel--types modern-panel--detail"
          [class.modern-panel--expanded]="eventTypesDetailsOpen"
          [attr.aria-expanded]="eventTypesDetailsOpen">
          <div class="modern-panel__title">
            <h2>Tipologie eventi</h2>
            <button type="button" mat-stroked-button class="modern-panel__details-trigger"
              (click)="toggleEventTypesDetails()" aria-controls="event-types-details-panel"
              [attr.aria-label]="eventTypesDetailsOpen ? 'Nascondi il dettaglio delle tipologie evento' : 'Vedi il dettaglio delle tipologie evento'">
              {{ eventTypesDetailsOpen ? 'Nascondi dettagli' : 'Vedi dettagli' }}
            </button>
          </div>
          @if(getWidget('alert_types')?.loading) {
          <div class="modern-panel__loader"><ion-spinner name="crescent"></ion-spinner></div>
          } @else {
          <div class="types-layout">
            <div class="types-donut">
              <div echarts [options]="modernAlertTypesOptions" [autoResize]="true"></div>
              <strong>{{ eventsTotal }}<small>Totale</small></strong>
            </div>
            <div class="types-list">
              @for(item of alertTypeItems; track item.key) {
              <div class="types-list__row">
                <span class="types-list__label"><i [style.background]="item.color"></i>{{ item.label }}</span>
                <b>{{ item.value }}</b>
                <span>{{ item.percentage }}%</span>
              </div>
              }
              <div class="types-list__total"><span>Totale</span><b>{{ eventsTotal }}</b></div>
            </div>
          </div>
          }
        </article>
        }

        @if(eventTypesDetailsOpen && isDashboardCardVisible('event_types')) {
        <article id="event-types-details-panel" class="modern-card kpi-details-panel event-types-details-panel"
          role="region" aria-live="polite" aria-labelledby="event-types-details-title">
          <header class="kpi-details-panel__header">
            <div class="kpi-details-panel__heading">
              <h2 id="event-types-details-title">Dettaglio tipologie eventi</h2>
            </div>
            <button type="button" mat-icon-button (click)="closeEventTypesDetails()"
              aria-label="Chiudi dettaglio tipologie eventi">
              <mat-icon>close</mat-icon>
            </button>
          </header>

          <section class="kpi-details-chart event-types-details-chart"
            aria-labelledby="event-types-details-chart-title">
            <div class="kpi-details-chart__header">
              <div class="kpi-details-chart__title">
                <h3 id="event-types-details-chart-title">Andamento per tipologia</h3>
              </div>
              <mat-button-toggle-group class="period-toggle kpi-comparison-mode"
                [value]="eventTypesComparisonMode"
                (change)="setEventTypesComparisonMode($event.value)"
                aria-label="Modalita di visualizzazione delle tipologie evento">
                <mat-button-toggle value="absolute">Valori</mat-button-toggle>
                <mat-button-toggle value="variation"
                  title="Variazione percentuale rispetto al primo valore disponibile">Variazione %</mat-button-toggle>
              </mat-button-toggle-group>
            </div>
            <div echarts [options]="eventTypesDetailsChartOptions" [autoResize]="true"
              class="event-types-details-chart__canvas"></div>
          </section>
        </article>
        }
        @if(heatmapDetailsOpen && isDashboardCardVisible('hourly_heatmap')) {
        <article id="heatmap-details-panel" class="modern-card modern-panel modern-panel--heatmap heatmap-details-panel"
          role="region" aria-live="polite" aria-labelledby="heatmap-details-title">
          <div class="modern-panel__title">
            <h2 id="heatmap-details-title">Fasce orarie pi&ugrave; attive &middot; {{ heatmapFilterLabel }}</h2>
            <mat-icon [matTooltip]="'Intensità degli eventi per giorno della settimana e fascia oraria nel periodo selezionato: ' + newDashboardPeriodContextLabel">info_outline</mat-icon>
            <button type="button" mat-icon-button class="modern-panel__settings" [matMenuTriggerFor]="modernHeatmapMenu"
              matTooltip="Filtra le allerte visualizzate" aria-label="Impostazioni fasce orarie">
              <mat-icon>tune</mat-icon>
            </button>
            <button type="button" mat-icon-button class="heatmap-details-panel__close"
              (click)="closeHeatmapDetails()" aria-label="Chiudi dettagli fasce orarie">
              <mat-icon>close</mat-icon>
            </button>
            <mat-menu #modernHeatmapMenu="matMenu" xPosition="before">
              <div class="menu-label">ALLERTE VISUALIZZATE</div>
              @for(option of heatmapFilterOptions; track option.value) {
              <button mat-menu-item (click)="onHeatmapFilterChange(option.value)">
                <div class="modern-filter-menu__option">
                  <span>{{ option.label }}</span>
                  @if(heatmapCurrentFilter === option.value) {
                  <mat-icon>check</mat-icon>
                  }
                </div>
              </button>
              }
            </mat-menu>
          </div>
          @if(heatmapDetailsLoading) {
          <div class="modern-panel__loader"><ion-spinner name="crescent"></ion-spinner></div>
          } @else if(heatmapDetailsUnavailable) {
          <div class="modern-empty">Dettaglio delle fasce orarie non disponibile</div>
          } @else if(heatmapRows.length) {
          <div class="heatmap">
            @for(row of heatmapRows; track row.day) {
            <div class="heatmap__row">
              <span>{{ row.label }}</span>
              <div class="heatmap__cells">
                @for(cell of row.values; track cell.hour) {
                <i [style.background]="heatmapCellColor(cell.value)"
                  [matTooltip]="row.label + ' - ' + cell.hour + ': ' + cell.value + ' eventi - ' + newDashboardPeriodContextLabel"></i>
                }
              </div>
            </div>
            }
            <div class="heatmap__hours">
              <span></span>
              <div>
                @for(hour of heatmapHours; track hour) {
                <small>{{ hour }}</small>
                }
              </div>
            </div>
            <div class="heatmap__legend">
              <span>Meno attivo</span>
              <div>
                <i style="background: rgba(37, 116, 255, .08)"></i>
                <i style="background: rgba(37, 116, 255, .25)"></i>
                <i style="background: rgba(37, 116, 255, .45)"></i>
                <i style="background: rgba(37, 116, 255, .7)"></i>
                <i style="background: rgba(37, 116, 255, 1)"></i>
              </div>
              <span>Pi&ugrave; attivo</span>
            </div>
          </div>
          } @else {
          <div class="modern-empty">Nessun dato orario disponibile</div>
          }
        </article>
        }
        @if(isDashboardCardVisible('managed_events_gauge')) {
        <article class="modern-card modern-panel modern-panel--managed-events modern-panel--detail"
          [class.modern-panel--expanded]="managedEventsDetailsOpen"
          [attr.aria-expanded]="managedEventsDetailsOpen">
          <div class="modern-panel__title">
            <h2>Eventi presi in carico</h2>
            <mat-icon matTooltip="Quante segnalazioni sono state gestite?">info_outline</mat-icon>
            <button type="button" mat-stroked-button class="modern-panel__details-trigger"
              (click)="toggleManagedEventsDetails()" aria-controls="managed-events-details-panel"
              [attr.aria-label]="managedEventsDetailsOpen ? 'Nascondi il dettaglio degli eventi presi in carico' : 'Vedi il dettaglio degli eventi presi in carico'">
              {{ managedEventsDetailsOpen ? 'Nascondi dettagli' : 'Vedi dettagli' }}
            </button>
          </div>
          @if(operationsSummaryLoading) {
          <div class="modern-panel__loader"><ion-spinner name="crescent"></ion-spinner></div>
          } @else if(operationsSummaryUnavailable) {
          <div class="modern-empty">Dati sugli eventi presi in carico non disponibili</div>
          } @else {
          <div class="managed-events-gauge">
            <div echarts [options]="managedEventsGaugeOptions" [autoResize]="true"
              class="managed-events-gauge__chart" role="img"
              [attr.aria-label]="managedEventsGaugeData.managed + ' segnalazioni gestite su ' + managedEventsGaugeData.total + ', pari al ' + managedEventsGaugeData.percentage + ' percento'"></div>
            <div class="managed-events-gauge__summary">
              <strong>{{ managedEventsGaugeData.managed | number:'1.0-0' }}</strong>
              <span>su {{ managedEventsGaugeData.total | number:'1.0-0' }}</span>
              <i aria-hidden="true">&middot;</i>
              <em>{{ managedEventsGaugeData.percentage }}%</em>
            </div>
            <p>Segnalazioni gestite nel periodo selezionato</p>
          </div>
          }
        </article>
        }
        @if(isSuperUser && isDashboardCardVisible('posture_statistics')) {
          @defer (on immediate) {
            <app-posture-statistics #postureCard class="dashboard-postures" [buildingId]="currentContext.buildingId" [unitId]="currentContext.unitId"
              [period]="newDashboardPeriod"
              (detailsOpenChange)="onPostureDetailsChange($event)"></app-posture-statistics>
          }
        }
        @if(managedEventsDetailsOpen && isDashboardCardVisible('managed_events_gauge')) {
        <article id="managed-events-details-panel"
          class="modern-card kpi-details-panel managed-events-details-panel"
          role="region" aria-live="polite" aria-labelledby="managed-events-details-title">
          <header class="kpi-details-panel__header">
            <div class="kpi-details-panel__heading">
              <h2 id="managed-events-details-title">Dettaglio eventi presi in carico</h2>
            </div>
            <button type="button" mat-icon-button (click)="closeManagedEventsDetails()"
              aria-label="Chiudi dettaglio eventi presi in carico">
              <mat-icon>close</mat-icon>
            </button>
          </header>

          @if(managedEventsDetailsLoading) {
          <div class="modern-panel__loader"><ion-spinner name="crescent"></ion-spinner></div>
          } @else if(managedEventsDetailsUnavailable) {
          <div class="modern-empty">Dettaglio degli eventi presi in carico non disponibile</div>
          } @else {
          <section class="kpi-details-chart managed-events-details-chart"
            aria-labelledby="managed-events-details-chart-title">
            <div class="kpi-details-chart__header">
              <div class="kpi-details-chart__title">
                <h3 id="managed-events-details-chart-title">Segnalazioni gestite e autogestite nel tempo</h3>
              </div>
            </div>
            <div echarts [options]="managedEventsDetailsChartOptions" [autoResize]="true"
              class="managed-events-details-chart__canvas"></div>
          </section>
          }
        </article>
        }
      </div>
    </section>

  </div>
  }
</ion-content>
